var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"event-type",class:{ sm: _vm.$mq === 'sm' }},[_vm._v(" "+_vm._s(_vm.event.event_type)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }